export const country = {
  countryName: 'United Kingdom',
  journeyList: [
    {
      stops: ['Kelvingrove park', 'Cathedral', 'George Square'],
      name: 'Glasgow adventure',
      ecoIndex: 99,
      price: '£100',
      imgs: [
        'https://external-content.duckduckgo.com/iu/?u=http%3A%2F%2Fwww.wow247.co.uk%2Fwp-content%2Fuploads%2F2015%2F01%2Funiversity-of-glasgow-tower.jpg&f=1&nofb=1',
        'https://external-content.duckduckgo.com/iu/?u=http%3A%2F%2Fwww.wow247.co.uk%2Fwp-content%2Fuploads%2F2015%2F01%2Funiversity-of-glasgow-tower.jpg&f=1&nofb=1',
        'https://external-content.duckduckgo.com/iu/?u=http%3A%2F%2Fwww.wow247.co.uk%2Fwp-content%2Fuploads%2F2015%2F01%2Funiversity-of-glasgow-tower.jpg&f=1&nofb=1'
      ]
    },
    {
      stops: ['Big Ben', 'Westminster'],
      name: 'London journey',
      ecoIndex: 59,
      imgs: [
        'https://static.thousandwonders.net/Big.Ben.original.18069.jpg',
        'https://static.thousandwonders.net/Big.Ben.original.18069.jpg',
        'https://static.thousandwonders.net/Big.Ben.original.18069.jpg',
        'https://static.thousandwonders.net/Big.Ben.original.18069.jpg'
      ],
      price: '£100'
    }
  ]
};
